import { useEffect, useRef } from "react";
import Phaser from "phaser";
import BoarHuntScene, { BoarEventType } from "./BoarHuntScene";

interface BoarHuntGameProps {
  /** true mentre la partita è in corso: monta il gioco quando true, lo smonta quando false */
  active: boolean;
  /** chiamata a ogni evento: cinghiale colpito, dorato colpito, coniglio colpito per errore, o fuga */
  onEvent: (type: BoarEventType) => void;
}

const GAME_HEIGHT = 320;

export default function BoarHuntGame({ active, onEvent }: BoarHuntGameProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const gameRef = useRef<Phaser.Game | null>(null);
  // Ref sempre aggiornata così la scena chiama sempre l'ultima versione
  // della callback, senza dover ricreare il gioco a ogni render.
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => {
    if (!active || !containerRef.current) return;

    const scene = new BoarHuntScene((type) => onEventRef.current(type));

    const game = new Phaser.Game({
      type: Phaser.AUTO,
      parent: containerRef.current,
      width: containerRef.current.clientWidth || 400,
      height: GAME_HEIGHT,
      backgroundColor: "#14532d",
      scene,
      scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
    });
    gameRef.current = game;

    return () => {
      scene.stopAll();
      game.destroy(true);
      gameRef.current = null;
    };
  }, [active]);

  return (
    <div
      ref={containerRef}
      className="w-full rounded-xl overflow-hidden border border-border"
      style={{ height: GAME_HEIGHT }}
    />
  );
}